var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 342,
    viewBox: "0 0 513 342",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_519)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.00878906H513V341.995H0V-0.00878906Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.0117188H513V341.987",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.031 241.617L207.798 250.138H216.757L209.51 255.403L212.278 263.922L205.031 258.658L197.784 263.922L200.551 255.403L193.304 250.138H202.261L205.031 241.617ZM182.152 159.836L186.766 174.036H201.696L189.617 182.81L194.231 197.009L182.152 188.233L170.074 197.009L174.689 182.81L162.609 174.036H177.539L182.152 159.836ZM182.152 263.922L186.765 278.123H201.696L189.616 286.897L194.231 301.097L182.152 292.321L170.074 301.097L174.687 286.897L162.609 278.123H177.537L182.152 263.922ZM225.803 197.009L230.418 211.209H245.348L233.269 219.984L237.883 234.184L225.803 225.408L213.726 234.184L218.341 219.984L206.261 211.209H221.191L225.803 197.009ZM138.5 197.009L143.115 211.209H158.043L145.966 219.984L150.578 234.184L138.5 225.408L126.422 234.184L131.036 219.984L118.957 211.209H133.886L138.5 197.009Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.261 119.053C369.619 111.41 359.689 106.896 349.017 106.12L380.96 81.2763C368.237 68.5535 351.188 62.8093 334.55 64.0247C332.497 56.6311 328.563 49.8957 323.132 44.4756L310.514 69.7108C309.668 68.1661 308.606 66.7501 307.36 65.5056C300.101 58.2464 288.332 58.2474 281.075 65.5056C273.818 72.7637 273.816 84.5327 281.075 91.7908C282.32 93.0363 283.736 94.0983 285.28 94.945L260.045 107.563C265.467 112.997 272.205 116.932 279.602 118.984C278.383 135.622 284.122 152.668 296.845 165.391L324.753 129.51C326.834 127.449 329.646 126.295 332.575 126.302C335.554 126.302 338.355 127.462 340.461 129.568C341.5 130.602 342.323 131.83 342.884 133.184C343.445 134.537 343.731 135.989 343.727 137.454C343.727 140.434 342.567 143.233 340.461 145.339L350.975 155.854C355.89 150.939 358.597 144.403 358.597 137.454C358.597 131.768 356.783 126.361 353.434 121.89C358.471 123.229 363.065 125.878 366.748 129.566C378.344 141.161 378.344 160.029 366.748 171.623L377.262 182.138C385.688 173.713 390.327 162.51 390.327 150.595C390.326 138.68 385.686 127.478 377.261 119.053Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_519"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 342,
    fill: "white",
    transform: "translate(0 -0.00878906)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPg);
export default __webpack_public_path__ + "static/media/PG.50a3db716f786ff3e63f9bfa7583b77d.svg";
export { ForwardRef as ReactComponent };